import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Ideation & Validation',
  desc: "We don't take outside pitches. We look for friction in our own workflows and markets we understand deeply, validating concepts before writing a single line of code."
}, {
  num: '02',
  title: 'Focused Execution',
  desc: 'Small, senior teams build the v1. No bloat, no endless meetings. We optimize for shipping high-quality, opinionated software quickly.'
}, {
  num: '03',
  title: 'Scale & Spin-out',
  desc: 'Once a product finds product-market fit, we build a dedicated team around it, allowing it to operate independently while sharing studio resources.'
}];
export function Approach() {
  return <section id="approach" className="py-32 px-6 md:px-12 bg-navy text-cream" data-id="element-16">
      <div className="max-w-7xl mx-auto" data-id="element-17">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-18">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="flex flex-col justify-between" data-id="element-19">
            <div data-id="element-20">
              <h2 className="text-sm font-sans font-semibold tracking-widest uppercase text-orange mb-6" data-id="element-21">
                Our Approach
              </h2>
              <h3 className="text-4xl md:text-6xl font-serif leading-tight text-balance" data-id="element-22">
                Not an agency. <br data-id="element-23" />
                Not a VC fund. <br data-id="element-24" />
                <span className="text-orange italic" data-id="element-25">A builder's studio.</span>
              </h3>
            </div>

            <div className="mt-12 lg:mt-0 text-lg text-cream/70 max-w-md font-light leading-relaxed" data-id="element-26">
              We operate as a holding company for our own ideas. By sharing
              infrastructure, design systems, and go-to-market strategies across
              our portfolio, we dramatically reduce the time it takes to launch
              new ventures.
            </div>
          </motion.div>

          {/* Right Column */}
          <div className="flex flex-col gap-12 lg:pt-24" data-id="element-27">
            {steps.map((step, index) => <motion.div key={step.num} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="group border-t border-cream/20 pt-8" data-id="element-28">
                <div className="flex items-baseline gap-6" data-id="element-29">
                  <span className="text-2xl font-serif text-orange" data-id="element-30">
                    {step.num}
                  </span>
                  <div data-id="element-31">
                    <h4 className="text-2xl font-serif mb-3 group-hover:text-orange transition-colors" data-id="element-32">
                      {step.title}
                    </h4>
                    <p className="text-cream/70 font-light leading-relaxed" data-id="element-33">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}